export interface Room {
  id: string
  slug: string
  name: string
  subtitle: string
  dropdownName?: string // Name für Dropdown-Navigation
  description: string
  fullDescription: string
  capacity: string
  features: string[]
  imageUrl: string
  galleryImages: string[]
}

export const rooms: Room[] = [
  {
    id: 'fest-scheune',
    slug: 'fest-scheune',
    name: 'Fest-Scheune',
    subtitle: 'Historisch & Wandelbar',
    description:
      'Unsere Fest-Scheune aus dem Jahre 1855 ist am Niederrhein sicher Beispielslos und bietet Ihnen eine außergewöhnliche Verwandlungsfähigkeit. Ob urig-rustikal, feierlich-festlich oder modern-kultig, die Möglichkeiten an ein einzigartiges Ambiente sind nahezu unbegrenzt.',
    fullDescription: `Unsere Fest-Scheune aus dem Jahre 1855 ist am Niederrhein sicher Beispielslos und bietet Ihnen eine außergewöhnliche Verwandlungsfähigkeit.

Ob urig-rustikal, feierlich-festlich oder modern-kultig, die Möglichkeiten an ein einzigartiges Ambiente sind nahezu unbegrenzt.

Ob Hochzeit oder Betriebsfest, Weihnachts- oder Familienfeiern, hier können wir fast alle Ihre Wünsche erfüllen.

Aufgeteilt in insgesamt 3 Bereiche (großer Saal, kleiner Saal & Galerie) ist eine sehr hohe Flexibilität je nach Personenzahl möglich.

Zu der Scheune gehört sowohl der große Außenbereich in unserem Innenhof sowie die große Terrasse hinter der Scheune.

Die Scheune ist daher ideal für Feiern ab mindestens 60 Personen geeignet.`,
    capacity: 'Ab 60 Personen',
    features: [
      '3 Bereiche (großer Saal, kleiner Saal & Galerie)',
      'Großer Außenbereich im Innenhof',
      'Große Südterrasse',
      'Flexible Raumaufteilung',
    ],
    // Einheitliche Raum-Bilder wie auf der Startseite: Ordner /assets/raume
    imageUrl: '/assets/raume/fest.jpg',
    galleryImages: [
      '/assets/galerie_neu/raum_galerie/festscheune_galerie/event-location_party-raum_scheune_hochzeitsfotos-krefeld.JPG',
      '/assets/galerie_neu/raum_galerie/festscheune_galerie/event-location_party-raum_scheune_hochzeit_bearbeitet.JPG',
      '/assets/galerie_neu/raum_galerie/festscheune_galerie/Hochzeit_16 Kopie.JPG',
      '/assets/galerie_neu/raum_galerie/festscheune_galerie/Hochzeit_3.JPG',
      '/assets/galerie_neu/raum_galerie/festscheune_galerie/Hochzeit_4.JPG',
      '/assets/galerie_neu/raum_galerie/festscheune_galerie/Hochzeit_6.JPG',
      '/assets/galerie_neu/raum_galerie/festscheune_galerie/IMG_4713_NEW.JPG',
    ],
  },
  {
    id: 'landhaus',
    slug: 'landhaus',
    name: 'Das Landhaus',
    subtitle: 'Südländisches Flair',
    description:
      'Aus dem ehemaligen Kuhstall ist auf zwei Ebenen ein ungewöhnlicher Raum entstanden. Terracotta-Böden in Verbindung mit den ursprünglichen Wänden geben diesem Raum sein südländisches Ambiente. Die vorgelagerte überdachte und windgeschützte Terrasse bietet zudem ausreichend Platz für bis zu 55 Personen.',
    fullDescription: `Aus dem ehemaligen Kuhstall ist auf zwei Ebenen ein ungewöhnlicher Raum entstanden. Terracotta-Böden in Verbindung mit den ursprünglichen Wänden geben diesem Raum sein südländisches Ambiente. Die vorgelagerte überdachte und windgeschützte Terrasse bietet zudem ausreichend Platz für bis zu 55 Personen und ist ganzjährig nutzbar.

Die sonnige Lage direkt am Innenhof geben Ihnen ein tolles sommerliches Gefühl. Mit maximal 52 Plätzen im Erdgeschoss sowie weiteren 26 Plätzen auf der Galerie ist dieser Raum auch ideal für kleinere Festlichkeiten oder Tagungen.`,
    capacity: '52 Plätze (EG) + 26 Plätze (Galerie)',
    features: [
      'Zwei Ebenen (Erdgeschoss & Galerie)',
      'Überdachte und windgeschützte Terrasse (bis 55 Personen)',
      'Ganzjährig nutzbar',
      'Sonnige Lage am Innenhof',
      'Ideal für Tagungen',
    ],
    imageUrl: '/assets/raume/land.jpg',
    galleryImages: [
      '/assets/galerie_neu/raum_galerie/landhaus_galerie/DSC01336 2.jpg',
      '/assets/galerie_neu/raum_galerie/landhaus_galerie/DSC01340 2.jpg',
      '/assets/galerie_neu/raum_galerie/landhaus_galerie/DSC01359 2.jpg',
      '/assets/galerie_neu/raum_galerie/landhaus_galerie/DSC01367 2.jpg',
      '/assets/galerie_neu/raum_galerie/landhaus_galerie/DSC01369 2.jpg',
      '/assets/galerie_neu/raum_galerie/landhaus_galerie/DSC01370 2.jpg',
      '/assets/galerie_neu/raum_galerie/landhaus_galerie/DSC01374 2.jpg',
      '/assets/galerie_neu/raum_galerie/landhaus_galerie/DSC01375 2.jpg',
      '/assets/galerie_neu/raum_galerie/landhaus_galerie/DSC01378 2.jpg',
      '/assets/galerie_neu/raum_galerie/landhaus_galerie/DSC01381 2.jpg',
      '/assets/galerie_neu/raum_galerie/landhaus_galerie/DSC01382 2.jpg',
      '/assets/galerie_neu/raum_galerie/landhaus_galerie/DSC01400 2.jpg',
    ],
  },
  {
    id: 'weinstube',
    slug: 'weinstube',
    name: 'Weinstube',
    dropdownName: 'Weinstube im Landhaus',
    subtitle: 'Charmant & Geborgen',
    description:
      'Willkommen in der Weinstube – einem charmanten Raum, der Wärme und Geborgenheit ausstrahlt. Sobald du die Tür öffnest, umarmt dich eine Atmosphäre von Wärme, Freundlichkeit und Geborgenheit. Direkt am Wintergarten des Innenhofs gelegen, kann dieser Raum auch wunderbar erweitert werden.',
    fullDescription: `Willkommen in der Weinstube – einem charmanten Raum, der Wärme und Geborgenheit ausstrahlt. Sobald du die Tür öffnest, umarmt dich eine Atmosphäre von Wärme, Freundlichkeit und Geborgenheit.

Direkt am Wintergarten des Innenhofs gelegen, kann dieser Raum auch Wunderbar erweitert werden. Mit maximal 30 Plätzen ist dieser Raum auch ideal für kleine Festlichkeiten im engsten Kreis.`,
    capacity: 'Maximal 30 Plätze',
    features: [
      'Direkt am Wintergarten des Innenhofs',
      'Erweiterbar',
      'Ideal für kleine Festlichkeiten',
      'Intime Atmosphäre',
    ],
    imageUrl: '/assets/raume/wein.jpg',
    galleryImages: [
      '/assets/galerie_neu/raum_galerie/weinstube_galerie/DSC01386 2.JPG',
      '/assets/galerie_neu/raum_galerie/weinstube_galerie/DSC01389 2.JPG',
      '/assets/galerie_neu/raum_galerie/weinstube_galerie/DSC01392 2 Kopie.JPG',
    ],
  },
  {
    id: 'innenhof',
    slug: 'innenhof',
    name: 'Der Innenhof',
    subtitle: 'Das Herzstück',
    description:
      'Willkommen in unserem Innenhof – dem strahlenden Herzen des Landguts, wo Natur und Eleganz zu einer unvergleichlichen Kulisse für besondere Veranstaltungen verschmelzen. Ein malerischer Innenhof, umgeben von antiken Mauern und üppigem Grün.',
    fullDescription: `Willkommen in unserem Innenhof – dem strahlenden Herzen des Landguts, wo Natur und Eleganz zu einer unvergleichlichen Kulisse für besondere Veranstaltungen verschmelzen. Ein malerischer Innenhof, umgeben von antiken Mauern und üppigem Grün, der eine Oase der Schönheit inmitten des Landguts bildet. Der gepflasterte Boden des Innenhofs ist von charmanten Blumenbeeten und duftenden Kräutergärten gesäumt, deren Farben und Düfte die Sinne beleben. Er bietet Platz für bis zu 400 Personen und ist flexibel gestaltbar, um verschiedenen Veranstaltungen gerecht zu werden. Von eleganten Empfängen bis hin zu lebendigen Festen – dieser vielseitige Ort kann individuell angepasst werden, um jedem Anlass das perfekte Ambiente zu verleihen.

Darüber hinaus ist der Innenhof nahtlos mit den anderen Räumen des Landguts verbunden, sodass Gäste die Freiheit haben, zwischen Innen- und Außenbereichen zu wechseln und das Beste aus beiden Welten zu genießen.

Ob Hochzeiten, Firmenfeiern oder private Jubiläen – der Innehof bietet die ideale Kulisse für unvergessliche Events inmitten von Natur und Eleganz.

Er verfügt insgesamt über drei Aussenbars sowie eine Outdoor Grillküche.`,
    capacity: 'Bis zu 400 Personen',
    features: [
      'Flexibel gestaltbar',
      'Nahtlos mit anderen Räumen verbunden',
      'Drei Außenbars',
      'Outdoor Grillküche',
      'Blumenbeete und Kräutergärten',
    ],
    imageUrl: '/assets/home_pics/HK_277.JPG',
    galleryImages: [
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/20181120_180026.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/event-location_innenhof_freie-trauung.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/event-location_party-raum_scheune_terrasse_1500.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/event-location_terrasse_grillstation.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/event-location_terrasse_grillstation_spanferkel.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/HK_136.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/HK_184.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/HK_229.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/HK_253.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/HK_260 Kopie 2.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/HK_269.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/HK_277.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/HK_324.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/HK_367.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/HK_447.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/HK_514.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/HK_551.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/HK_609.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/HK_657.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/HK_766.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/HK_798.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/IMG-20180831-WA0001~01.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/LL_224.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/LL_234.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/LL_265.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/LL_361.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/LL_404.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/LL_412.JPG',
      '/assets/galerie_neu/raum_galerie/innenhof_galerie/LL_494.JPG',
    ],
  },
]

export const getRoomBySlug = (slug: string): Room | undefined => {
  return rooms.find((room) => room.slug === slug)
}

